import React, { useState, useEffect } from "react";

import { Container, Row, Col, Form } from "react-bootstrap";
import api from "../../../api";
import ButtonLoader from "components/Common/ButtonLoader";
import { Link, useHistory } from "react-router-dom";
import { CreateStoreRecord } from "../../../services/StoreServices";
import { checkPermissionStatus } from "helpers/utils";
import { decryptDataFromArray, encryptDataToArray } from "helpers/EncDec";
import {
  FetchCityList,
  FetchRegionList,
  FetchStateList,
} from "services/locationService";
import arrow_btn from "../../../assets/images/icon/arrow-btn.svg";
import { GetCompanyData } from "services/CompanyService";
import { useTranslation } from "react-i18next";

const CreateStore = props => {
  const { t } = useTranslation();
  const history = useHistory();
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [StorePayload, setStorePayload] = useState({});
  const [StoreManager, setStoreManager] = useState([]);
  const [Country, setCountry] = useState([]);
  const [Region, setRegion] = useState([]);
  const [State, setState] = useState([]);
  const [City, setCity] = useState([]);

  const [countryIdSelected, setCountryIdSelected] = useState(false);

  const handleInput = event => {
    const { name, value } = event.target;

    setStorePayload(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleManagerSelection = store_manager => {
    setStorePayload(prevState => ({
      ...prevState,
      store_manager: store_manager,
    }));
  };

  const handleCountrySelection = CountryID => {
    setStorePayload(prevState => ({
      ...prevState,
      country_id: CountryID,
      region_id: null,
      state_id: null,
      city_id: null,
    }));
  };
  const handleRegionSelection = RegionID => {
    const selectedRegionId = RegionID || "";
    setStorePayload(prevState => ({
      ...prevState,
      region_id: selectedRegionId,
      state_id: null,
      city_id: null,
    }));
  };
  const handleStateSelection = StateID => {
    setStorePayload(prevState => ({
      ...prevState,
      state_id: StateID,
      city_id: null,
    }));
  };
  const handleCitySelection = CityID => {
    setStorePayload(prevState => ({
      ...prevState,
      city_id: CityID,
    }));
  };

  const createNewStore = payload => {
    CreateStoreRecord(payload)
      .then(response => {
        setIsLoading(false);
        history.push("/store-list");
      })
      .catch(err => {
        setIsLoading(false);
        console.log("Error:", err);
      });
  };

  const handleSubmit = event => {
    event.preventDefault();
    setErrors({});
    setIsLoading(true);
    let errorObj = {};

    if (!StorePayload?.store_number) {
      errorObj["store_number"] = t(`Location_Manager.Store number required`);
    }
    if (!StorePayload?.store_name) {
      errorObj["store_name"] = t(`Location_Manager.Store name required`);
    }
    // if (!StorePayload?.store_manager) {
    //   errorObj["store_manager"] = "Store manager is required";
    // }
    if (!StorePayload?.store_address1) {
      errorObj["store_address1"] = t(`Location_Manager.Store address required`);
    }

    if (!StorePayload?.country_id) {
      errorObj["country_id"] = t(`Location_Manager.Country required`);
    }

    // if (!StorePayload?.region_id) {
    //   errorObj["region_id"] = "Region is required";
    // }

    if (!StorePayload?.state_id) {
      errorObj["state_id"] = t(`Location_Manager.State required`);
    }

    if (!StorePayload?.city_id) {
      errorObj["city_id"] = t(`Location_Manager.City required`);
    }

    if (!StorePayload?.status) {
      errorObj["status"] = t(`Location_Manager.Status required`);
    }

    if (Object.keys(errorObj)?.length > 0) {
      setIsLoading(false);
      setErrors(prevState => ({
        ...prevState,
        ...errorObj,
      }));

      return;
    }

    const reqData = {
      store_number: StorePayload?.store_number,
      store_name: StorePayload?.store_name,
      channel: StorePayload?.channel,
      store_manager: StorePayload?.store_manager,
      store_address1: StorePayload?.store_address1,
      store_address2: StorePayload?.store_address2,
      pincode: StorePayload?.pincode,
      latitude: StorePayload?.latitude,
      longitude: StorePayload?.longitude,
      country_id: StorePayload?.country_id,
      region_id: StorePayload?.region_id,
      state_id: StorePayload?.state_id,
      city_id: StorePayload?.city_id,
      status: StorePayload?.status,
    };
    const encryptedQuery = encryptDataToArray(reqData);

    let payload = new FormData();
    payload.append("reqData", JSON.stringify(encryptedQuery));

    // setting payload to save inside the database;
    // let payload = new FormData();
    // payload.append("store_number", StorePayload?.store_number);
    // payload.append("store_name", StorePayload?.store_name);
    // payload.append("channel", StorePayload?.channel);
    // payload.append("store_manager", StorePayload?.store_manager);
    // payload.append("store_address1", StorePayload?.store_address1);
    // payload.append("store_address2", StorePayload?.store_address2);
    // payload.append("pincode", StorePayload?.pincode);
    // payload.append("latitude", StorePayload?.latitude);
    // payload.append("longitude", StorePayload?.longitude);
    // payload.append("state_id", StorePayload?.state);
    // payload.append("city_id", StorePayload?.city);
    // payload.append("franchise_id", StorePayload?.franchise);
    // payload.append("status", StorePayload?.status);

    // Calling the api and saving data;
    createNewStore(payload);
  };

  const fetchStoreManagerData = () => {
    api
      .get(`${process.env.REACT_APP_API_URL}/admin/store/store-manager`)
      .then(response => {
        const allManager = response.data.data;
        let data = allManager?.map(item => ({
          id: item?.id,
          label: item?.name,
          value: item?.name,
        }));
        setStoreManager(data);
      })
      .catch(err => console.log("Error:::", err));
  };
  const fetchCountryData = () => {
    api
      .get(`${process.env.REACT_APP_API_URL}/admin/location/country-list`)
      .then(response => {
        const { success, allCountry } = response.data;
        if (success) {
          const { allCountry } = response.data;
          let data = allCountry?.map(item => ({
            id: item?.id,
            label: item?.name,
            value: item?.name,
          }));
          setCountry(data);
        }
      })
      .catch(err => console.log("Error:::", err));
  };
  const fetchRegionData = () => {
    FetchRegionList()
      .then(res => {
        let response = decryptDataFromArray(res?.data);
        const allRegion = response?.data?.filter(item => item.status === 1) || [];
        let data = allRegion?.map(item => ({
          id: item?.id,
          label: item?.region,
          value: item?.region,
          country_id: item?.country_id,
        }));
        setRegion(data);
      })
      .catch(err => console.log("Error:::", err));
  };
  const fetchStateData = () => {
    FetchStateList()
      .then(res => {
        let response = decryptDataFromArray(res?.data);
        const allState = response?.data?.filter(item => item.status === 1) || [];
        let data = allState?.map(item => ({
          id: item?.id,
          label: item?.name,
          value: item?.name,
          country_id: item?.country_id,
          region_id: item?.region_id,
        }));
        setState(data);
      })
      .catch(err => console.log("Error:::", err));
  };

  const fetchCity = () => {
    FetchCityList()
      .then(res => {
        let response = decryptDataFromArray(res?.data);
        const allCity = response?.data?.filter(item => item.status === 1) || [];
        let data = allCity?.map(item => ({
          id: item?.id,
          label: item?.city,
          value: item?.city,
          country_id: item?.country_id,
          region_id: item?.region_id,
          state_id: item?.state_id,
        }));
        setCity(data);
      })
      .catch(err => console.log("Error:::", err));
  };

  useEffect(() => {
    GetCompanyData()
      .then(res => {
        let companyData = res?.data?.data || {};

        setStorePayload(prevState => ({
          ...prevState,
          country_id: companyData?.country_id,
        }));

        if (companyData?.country_id) {
          setCountryIdSelected(true);
        }
      })
      .catch(err => {});

    fetchStoreManagerData();
    fetchCountryData();
    fetchRegionData();
    fetchStateData();
    fetchCity();

    return () => {};
  }, []);

 

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

   if (!checkPermissionStatus("store-list", "create")) {
    return (
      <div className="page-content">
        <h4 className="text-center">{t(`Location_Manager.Access Denied`)}</h4>
      </div>
    );
  }

  return (
    <div className="page-content only-form-padding">
      <Container fluid>
        {/* <Row className="mb-3 align-items-center border-bottom py-2 pt-0">
          <Col lg="6" md="6">
            <h5 className="text-uppercase heading-one">Create Store</h5>
          </Col>

          <Col lg="6" md="6">
            <div className="single-filter-box btn-left d-flex justify-content-end align-items-center gap-2">
              <Link to="/store-list" className="btn btn-primary">
                Back To Listing
              </Link>
            </div>
          </Col>
        </Row> */}

        <div className="joblist-container create-vacancy">
          <Row className="mb-3 align-items-center">
            <Col lg="6" md="6">
              <Link to="/store-list">
                <h5 className="text-uppercase heading-one">
                  <img src={arrow_btn} alt="arrow_btn" />
                  {t(`Location_Manager.Create Store`)}
                </h5>
              </Link>
            </Col>
            {/* <Col lg="6" md="6">
              <div className="single-filter-box btn-left d-flex justify-content-end align-items-center gap-2">
                <Link to="/department-list" className="btn btn-primary">
                  Back To Listing
                </Link>
              </div>
            </Col> */}
          </Row>
        </div>

        {/* <h2 className="heading-two">Store Details:</h2> */}

        <div className="outerTab-box-wrapper below-vacancy">
          <div className="form-details-section mt-3">
            <Row>
              <Form.Group className="col-md-6 col-lg-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Location_Manager.Store Number`)}*
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t(`Location_Manager.Store Number`)}
                  name="store_number"
                  value={StorePayload?.store_number}
                  onChange={handleInput}
                />
                {errors?.store_number && (
                  <small className="text-danger">
                    {" "}
                    {errors?.store_number}{" "}
                  </small>
                )}
              </Form.Group>
              <Form.Group className="col-md-6 col-lg-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Location_Manager.Store Name`)}*
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t(`Location_Manager.Store Name`)}
                  name="store_name"
                  value={StorePayload?.store_name}
                  onChange={handleInput}
                />
                {errors?.store_name && (
                  <small className="text-danger"> {errors?.store_name} </small>
                )}
              </Form.Group>
              <Form.Group className="col-md-6 col-lg-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Location_Manager.Channel`)}
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t(`Location_Manager.Channel`)}
                  name="channel"
                  value={StorePayload?.channel}
                  onChange={handleInput}
                />
                {errors?.channel && (
                  <small className="text-danger"> {errors?.channel} </small>
                )}
              </Form.Group>
              <Form.Group className="col-md-6 col-lg-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Location_Manager.Store Manager`)}
                </Form.Label>
                <select
                  type="select"
                  name="store_manager"
                  className="col-md-6 mb-1 form-control form-select"
                  style={{ width: "100%" }}
                  onChange={e => handleManagerSelection(e.target?.value)}
                >
                  <option value="" selected>
                    {t(`Location_Manager.Select Store Manager`)}
                  </option>
                  {StoreManager &&
                    StoreManager.map(el => {
                      return (
                        <option key={el?.value} value={el?.id}>
                          {el?.label}
                        </option>
                      );
                    })}
                </select>
                {errors?.store_manager && (
                  <small className="text-danger">
                    {" "}
                    {errors?.store_manager}{" "}
                  </small>
                )}
              </Form.Group>
              <Form.Group className="col-md-6 col-lg-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Location_Manager.Store Address1`)}*
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t(`Location_Manager.Store Address1`)}
                  name="store_address1"
                  value={StorePayload?.store_address1}
                  onChange={handleInput}
                />
                {errors?.store_address1 && (
                  <small className="text-danger">
                    {" "}
                    {errors?.store_address1}{" "}
                  </small>
                )}
              </Form.Group>
              <Form.Group className="col-md-6 col-lg-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Location_Manager.Store Address2`)}
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t(`Location_Manager.Store Address2`)}
                  name="store_address2"
                  value={StorePayload?.store_address2}
                  onChange={handleInput}
                />
                {errors?.store_address2 && (
                  <small className="text-danger">
                    {" "}
                    {errors?.store_address2}{" "}
                  </small>
                )}
              </Form.Group>
              <Form.Group className="col-md-6 col-lg-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Location_Manager.Pincode`)}
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t(`Location_Manager.Pincode`)}
                  name="pincode"
                  value={StorePayload?.pincode}
                  onChange={handleInput}
                />
                {errors?.pincode && (
                  <small className="text-danger"> {errors?.pincode} </small>
                )}
              </Form.Group>
              <Form.Group className="col-md-6 col-lg-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Location_Manager.Latitude`)}
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t(`Location_Manager.Latitude`)}
                  name="latitude"
                  value={StorePayload?.latitude}
                  onChange={handleInput}
                />
                {errors?.latitude && (
                  <small className="text-danger"> {errors?.latitude} </small>
                )}
              </Form.Group>
              <Form.Group className="col-md-6 col-lg-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Location_Manager.Longitude`)}
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t(`Location_Manager.Longitude`)}
                  name="longitude"
                  value={StorePayload?.longitude}
                  onChange={handleInput}
                />
                {errors?.longitude && (
                  <small className="text-danger"> {errors?.longitude} </small>
                )}
              </Form.Group>

              <Form.Group className="col-md-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Location_Manager.Country`)}
                  <span className="text-danger">*</span>
                </Form.Label>

                <select
                  type="select"
                  name="country_id"
                  className="col-md-6 mb-1 form-control form-select"
                  style={{ width: "100%" }}
                  onChange={e => handleCountrySelection(e.target?.value)}
                  value={StorePayload?.country_id}
                  disabled={countryIdSelected === true}
                >
                  <option value="" selected>
                    {t(`Location_Manager.Select Country`)}
                  </option>
                  {Country &&
                    Country.map(el => {
                      return (
                        <option key={el?.value} value={el?.id}>
                          {el?.label}
                        </option>
                      );
                    })}
                </select>
                {errors?.country_id && (
                  <small className="text-danger"> {errors?.country_id} </small>
                )}
              </Form.Group>
              <Form.Group className="col-md-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Location_Manager.Region`)}
                  {/* <span className="text-danger">*</span> */}
                </Form.Label>

                <select
                  type="select"
                  name="region_id"
                  className="col-md-6 mb-1 form-control form-select"
                  style={{ width: "100%" }}
                  onChange={e => handleRegionSelection(e.target?.value)}
                >
                  <option value="" selected>
                    {t(`Location_Manager.Select Region`)}
                  </option>
                  {Region &&
                    Region?.filter(
                      reg => reg?.country_id == StorePayload?.country_id
                    )?.map(el => {
                      return (
                        <option key={el?.value} value={el?.id}>
                          {el?.label}
                        </option>
                      );
                    })}
                </select>
                {errors?.region_id && (
                  <small className="text-danger"> {errors?.region_id} </small>
                )}
              </Form.Group>
              <Form.Group className="col-md-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Location_Manager.State`)}
                  <span className="text-danger">*</span>
                </Form.Label>

                <select
                  type="select"
                  name="state_id"
                  className="col-md-6 mb-1 form-control form-select"
                  style={{ width: "100%" }}
                  onChange={e => handleStateSelection(e.target?.value)}
                >
                  <option value="" selected>
                    {t(`Location_Manager.Select State`)}
                  </option>
                  {State &&
                    State?.filter(st => {
                      let flag = false;
                      if (
                        StorePayload?.country_id &&
                        !StorePayload?.region_id
                      ) {
                        flag = st?.country_id == StorePayload?.country_id;
                      } else if (
                        StorePayload?.country_id &&
                        StorePayload?.region_id
                      ) {
                        flag =
                          st?.country_id == StorePayload?.country_id &&
                          st?.region_id == StorePayload?.region_id;
                      }

                      return flag;
                    }).map(el => {
                      return (
                        <option key={el?.value} value={el?.id}>
                          {el?.label}
                        </option>
                      );
                    })}
                </select>
                {errors?.state_id && (
                  <small className="text-danger"> {errors?.state_id} </small>
                )}
              </Form.Group>

              <Form.Group className="col-md-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Location_Manager.City`)}
                  <span className="text-danger">*</span>
                </Form.Label>
                <select
                  type="select"
                  name="city_id"
                  className="col-md-6 mb-1 form-control form-select"
                  style={{ width: "100%" }}
                  onChange={e => handleCitySelection(e.target?.value)}
                >
                  <option value="" selected>
                    {t(`Location_Manager.Select City`)}
                  </option>
                  {City &&
                    City?.filter(city => {
                      let flag = false;

                      let { country_id, region_id, state_id } =
                        StorePayload || {};

                      if (country_id && region_id && state_id) {
                        flag =
                          country_id == city?.country_id &&
                          region_id == city?.region_id &&
                          state_id == city?.state_id;
                      } else if (country_id && !region_id && state_id) {
                        flag =
                          country_id == city?.country_id &&
                          state_id == city?.state_id;
                      }

                      return flag;
                    }).map(el => {
                      return (
                        <option key={el?.value} value={el?.id}>
                          {el?.label}
                        </option>
                      );
                    })}
                </select>
                {errors?.city_id && (
                  <small className="text-danger"> {errors?.city_id} </small>
                )}
              </Form.Group>

              <Form.Group className="col-md-6 col-lg-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Location_Manager.Status`)}*
                </Form.Label>
                <select
                  type="select"
                  name="status"
                  className="col-md-6 mb-1 form-control form-select"
                  style={{ width: "100%" }}
                  onChange={handleInput}
                >
                  <option value="" defaultValue>
                    {t(`Location_Manager.Select Status`)}
                  </option>
                  <option value="1">{t(`Location_Manager.Active`)}</option>
                  <option value="0">{t(`Location_Manager.Inactive`)}</option>
                </select>
                {errors?.status && (
                  <small className="text-danger"> {errors?.status} </small>
                )}
              </Form.Group>

              <Form.Group className="cta  gap-3 text-center d-flex justify-content-start mt-4 pb-2">
                <Link
                  to="/store-list"
                  style={{ marginLeft: "5px" }}
                  className="btn btn-secondary"
                >
                  {t(`Location_Manager.Cancel`)}
                </Link>
                <ButtonLoader
                  title={t(`Location_Manager.Save Details`)}
                  variant="primary"
                  style={{ marginLeft: "5px" }}
                  type="submit"
                  loading={isLoading}
                  message={t(`Location_Manager.Saving`)}
                  onClick={e => {
                    handleSubmit(e);
                  }}
                />
              </Form.Group>
            </Row>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default CreateStore;
